import { create } from 'zustand';
import { toast } from 'sonner';
import {
    settingsService,
    TeamSettings,
    UpdateTeamSettingsDto,
} from '../services/settings.service';

interface SettingsState {
    // State
    settings: TeamSettings | null;
    isLoading: boolean;
    error: string | null;

    // Actions
    fetchSettings: () => Promise<void>;
    updateSettings: (data: UpdateTeamSettingsDto) => Promise<void>;
    clearError: () => void;
}

export const useSettingsStore = create<SettingsState>((set) => ({
    // Initial State
    settings: null,
    isLoading: false,
    error: null,

    // Actions
    fetchSettings: async () => {
        set({ isLoading: true, error: null });
        try {
            const settings = await settingsService.getSettings();
            set({ settings, isLoading: false });
        } catch (error) {
            console.error('Failed to fetch settings:', error);
            set({ error: 'Failed to load settings', isLoading: false });
        }
    },

    updateSettings: async (data: UpdateTeamSettingsDto) => {
        try {
            const settings = await settingsService.updateSettings(data);
            set({ settings });
            toast.success('Settings saved successfully');
        } catch (error) {
            console.error('Failed to update settings:', error);
            toast.error('Failed to save settings');
            throw error;
        }
    },

    clearError: () => set({ error: null }),
}));
